export const LUXURY_X = {
 A: 15,   B: 20,
  C: 25,  D: 38, E: 43, F: 48, G: 53, H: 58,I:63,
  J: 76,  K: 81, L:86
};
export const LUXURY_Y = {
1: -48,
  2: -43, 3: -38, 4: -33, 5: -28, 6: -23, 7: -17,
  8: 13, 9: 18, 10:23, 11: 28,12:33,13:38,14:43,15:48,16:53,17:58
};
export const ROYAL_X = {
  A: 17,   B: 22,
  C: 35,  D: 40, E: 45, F: 50, G: 55, H: 60,I:70,
  J: 75,  K: 80
};
export const ROYAL_Y = {
  1:35,   2: 40, 3: 45,  4: 50,
  5: 55,  6: 60,
  7: 65,  8: 70, 9: 75, 10:80, 11: 85,
  12: 90
};
